export const AUTH_TOKEN_NAME = 'AUTH_TOKEN';
export const USER_ID_NAME = 'USER_ID';
